module.exports = __webpack_public_path__ + "static/media/explain.22118224.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/explain.png
// module id = 1822
// module chunks = 0